const featureList = (state = null, action) => {
    if (action.type === "SET_FEATURE_LIST") {
        return action.payload;
    } else {
        return state;
    }
};

export default featureList;
